import { f as O, V as b, s as j, C as P, t as h, q as E, b as T, J as I, c as R } from "./export-cdcbfb2b.js";
import { o as $ } from "./object-keys-719a5561.js";
var d = O, m = !d(function() {
  function r() {
  }
  return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), _ = j, C = P, G = h, K = b, g = m, v = K("IE_PROTO"), o = Object, w = o.prototype, x = g ? o.getPrototypeOf : function(r) {
  var e = G(r);
  if (_(e, v))
    return e[v];
  var t = e.constructor;
  return C(t) && e instanceof t ? t.prototype : e instanceof o ? w : null;
}, i = E, U = O, l = T, k = x, A = $, D = R, S = I.f, p = l(S), q = l([].push), B = i && U(function() {
  var r = /* @__PURE__ */ Object.create(null);
  return r[2] = 2, !p(r, 2);
}), u = function(r) {
  return function(e) {
    for (var t = D(e), n = A(t), f = B && k(t) === null, y = n.length, s = 0, c = [], a; y > s; )
      a = n[s++], (!i || (f ? a in t : p(t, a))) && q(c, r ? [a, t[a]] : t[a]);
    return c;
  };
}, M = {
  // `Object.entries` method
  // https://tc39.es/ecma262/#sec-object.entries
  entries: u(!0),
  // `Object.values` method
  // https://tc39.es/ecma262/#sec-object.values
  values: u(!1)
};
export {
  x as a,
  M as o
};
